import styled from 'styled-components';

import {
  MOBILE_PADDING,
  SCREEN_LOCKUP_WIDTH,
  PAGE_WIDTH,
  WHITE,
  NAVIGATION_DESKTOP_HEIGHT,
  NAVIGATION_MOBILE_HEIGHT,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.section`
  position: relative;
  padding: ${20 + NAVIGATION_MOBILE_HEIGHT}px ${MOBILE_PADDING}px 3em;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: -${NAVIGATION_MOBILE_HEIGHT}px auto 0;
  background-color: #000;

  ${media.tabletL`
    padding: ${86 + NAVIGATION_DESKTOP_HEIGHT}px ${MOBILE_PADDING}px 6em;
    margin: -${NAVIGATION_DESKTOP_HEIGHT}px auto 6em;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
`;

export const ContentWrapper = styled.div`
  text-align: center;
  color: ${WHITE};
  max-width: 940px;

  ${media.tabletL`
    margin: 0 auto;
    text-align: center;
  `};
`;

export const ContentTop = styled.div`
  color: ${WHITE};

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
  `};
`;

export const HeroImageWrapper = styled.div`
  ${media.tabletL`
    max-width: 575px;
    width: 55%;
  `};
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  width: 100%;

  ${media.tabletL`
    align-items: stretch;
    justify-content: center;
    margin-top: 0;
    max-width: 40%;
  `};
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 1.14;
  letter-spacing: 0.4px;
  margin: 0;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  color: ${WHITE};

  ${media.tabletL`
    font-size: 40px;
    font-weight: 600;
    line-height: 1.13;
    letter-spacing: 0.1px;
    text-align: left;
  `};

  ${media.desktop`
    font-size: 48px;
  `};
`;

export const BodyTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  margin: 15px 0 0 0;
  text-transform: uppercase;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    text-align: left;
  `};

  ${media.desktop`
    margin: 25px 0 0 0;
  `};
`;

export const Body = styled.p`
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  margin: 10px 0 0 0;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    font-size: 16px;
    text-align: left;
  `};

  ${media.desktop`
    font-size: 18px;
    margin: 20px 0 0 0;
  `};
`;

export const Description = Body;

export const Subtitles = styled.div`
  color: ${WHITE};
  margin: 2em auto 0;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  min-height: 150px;
  width: 100%;

  ${media.tabletP`
    display: flex;
    margin: 4.5em auto 0;
  `};
`;

export const Subtitle = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;

  h2 {
    font-size: 14px;
    line-height: 1.25em;
    min-height: 34px;
    max-width: 240px;
    text-align: center;
    text-transform: uppercase;

    ${media.tabletL`
      font-size: 18px;
      text-align: left;
    `};

    > span {
      font-weight: 400;
    }
  }

  p {
    font-size: 40px;
    max-width: 240px;
    margin: 0 0 5px;
    text-align: center;

    ${media.tabletL`
      font-size: 52px;
      text-align: left;
    `};
  }

  ul {
    padding-left: 1em;
  }

  li {
    line-height: 1.5em;
  }

  ${media.tabletP`
    border-right: 1px solid ${WHITE};

    &:last-child {
      border-right: none;
    }
  `};

  ${media.desktop`
    border-left: 1px solid ${WHITE};
    border-right: none;

    &:last-child {
      border-right: 1px solid ${WHITE};
    }
  `};
`;

export const SubtitleList = Subtitle.extend`
  flex: 1.5;
`;

export const Text = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 19px;

  ${media.tabletL`
    align-items:flex-start;
  `};
`;

export const SubtitleH2 = styled.h2`
  color: ${WHITE};
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/SeminarHero/SeminarHero.style.js